import {
  BookOpen01Icon,
  Building02Icon,
  BundleIcon,
  CalendarCheck01Icon,
  CheckCircleIcon,
  Coins02Icon,
  CreditCard01Icon,
  CursorClick01Icon,
  EyeIcon,
  FilterFunnel01Icon,
  Globe01Icon,
  GraduationHat02Icon,
  ImageIndentLeftIcon,
  Mail05Icon,
  PlayCircleIcon,
  SlashCircle01Icon,
  Tag01RemoveIcon,
  Tag02Icon,
  Users03Icon,
  VideoRecorderIcon,
} from '@systemeio/icons'
import { ruleIconClassName } from 'modules/automation-rules/constants/automation-rule-icon-class'
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import React from 'react'

export const getTriggerIcon = (trigger: AutomationRuleTriggersEnum): React.JSX.Element => {
  switch (trigger) {
    case AutomationRuleTriggersEnum.tag_added:
      return <Tag02Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.tag_removed:
      return <Tag01RemoveIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.registered_to_webinar:
      return <VideoRecorderIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.enrolled_in_course:
      return <GraduationHat02Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.course_completed:
      return <CheckCircleIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.module_completed:
      return <BookOpen01Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.lecture_completed:
      return <PlayCircleIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.form_subscribed:
      return <FilterFunnel01Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.blog_page_form_subscribed:
      return <ImageIndentLeftIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.website_form_subscribed:
      return <Globe01Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.digital_store_form_subscribed:
      return <Building02Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.enrolled_in_course_bundle:
      return <BundleIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.campaign_completed:
      return <CheckCircleIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.new_sale:
      return <Coins02Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.sale_canceled:
      return <SlashCircle01Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.email_link_clicked:
      return <CursorClick01Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.email_opened:
      return <Mail05Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.page_visited:
      return <EyeIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.enrolled_in_community:
      return <Users03Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.subscription_payment_failed:
      return <CreditCard01Icon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.booking_created:
      return <CalendarCheck01Icon className={ruleIconClassName} />
  }
}
